import { useForm, Link, router } from '@inertiajs/react'
import { useState } from 'react'
import AdminLayout from '../../../components/AdminLayout'
import { UploadField } from '../../../components/admin/UploadField'

export default function AdminProductsNew() {
  const [selectedFiles, setSelectedFiles] = useState<File[]>([])
  const { data, setData, processing } = useForm({
    name: '',
    description: '',
    price: '',
    stock: '',
    product_type: 'one_of_one',
    category: '',
    customizable: 'false',
    listed: 'true',
  })

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()

    const formData = new FormData()
    formData.append('name', data.name)
    formData.append('description', data.description)
    formData.append('price', data.price)
    formData.append('stock', data.stock)
    formData.append('product_type', data.product_type)
    formData.append('category', data.category)
    formData.append('customizable', data.customizable)
    formData.append('listed', data.listed)
    selectedFiles.forEach((file) => formData.append('images[]', file))

    router.post('/admin/products', formData, { forceFormData: true })
  }

  return (
    <AdminLayout>
      <Link href="/admin/products" className="sss-admin-back">
        ← Back to products
      </Link>

      <div className="sss-admin-head">
        <p className="sss-admin-eyebrow sss-admin-eyebrow--accent">Catalog</p>
        <h1 className="sss-admin-title">Add product</h1>
      </div>

      <div className="sss-admin-card" style={{ maxWidth: 720 }}>
        <div className="sss-admin-card__body">
          <form onSubmit={handleSubmit} className="sss-admin-form">
            <div className="sss-admin-field">
              <label htmlFor="name" className="sss-admin-label">
                Product name *
              </label>
              <input
                id="name"
                type="text"
                className="sss-admin-input"
                value={data.name}
                onChange={(e) => setData('name', e.target.value)}
                required
              />
            </div>

            <div className="sss-admin-field">
              <label htmlFor="description" className="sss-admin-label">
                Description
              </label>
              <textarea
                id="description"
                rows={4}
                className="sss-admin-textarea"
                value={data.description}
                onChange={(e) => setData('description', e.target.value)}
              />
            </div>

            <div className="sss-admin-grid-2">
              <div className="sss-admin-field">
                <label htmlFor="price" className="sss-admin-label">
                  Price *
                </label>
                <div className="sss-admin-price-wrap">
                  <span className="sss-admin-price-wrap__sign">$</span>
                  <input
                    id="price"
                    type="number"
                    step="0.01"
                    min="0"
                    className="sss-admin-input sss-admin-input--price"
                    value={data.price}
                    onChange={(e) => setData('price', e.target.value)}
                    required
                  />
                </div>
              </div>
              <div className="sss-admin-field">
                <label htmlFor="stock" className="sss-admin-label">
                  Stock *
                </label>
                <input
                  id="stock"
                  type="number"
                  min="0"
                  className="sss-admin-input"
                  value={data.stock}
                  onChange={(e) => setData('stock', e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="sss-admin-grid-2">
              <div className="sss-admin-field">
                <label htmlFor="category" className="sss-admin-label">
                  Category
                </label>
                <select
                  id="category"
                  className="sss-admin-select"
                  value={data.category}
                  onChange={(e) => setData('category', e.target.value)}
                >
                  <option value="">No category — off the landing rows</option>
                  <option value="apple">Apple</option>
                  <option value="lighter_cases">Lighter cases</option>
                  <option value="vape_cases">Vape cases</option>
                  <option value="airpods_pro_cases">AirPods Pro cases</option>
                </select>
              </div>
              <div className="sss-admin-field">
                <label htmlFor="product_type" className="sss-admin-label">
                  Product type
                </label>
                <select
                  id="product_type"
                  className="sss-admin-select"
                  value={data.product_type}
                  onChange={(e) => setData('product_type', e.target.value)}
                >
                  <option value="one_of_one">1 of 1 — a single piece</option>
                  <option value="mass_produced">Mass produced — made in batches</option>
                  <option value="custom">Custom — made to order, design agreed after payment</option>
                </select>
              </div>
              <div className="sss-admin-field">
                <label htmlFor="listed" className="sss-admin-label">
                  Visibility
                </label>
                <select
                  id="listed"
                  className="sss-admin-select"
                  value={data.listed}
                  onChange={(e) => setData('listed', e.target.value)}
                >
                  <option value="true">Listed — shown in the shop</option>
                  <option value="false">Unlisted — hidden, kept on past orders</option>
                </select>
              </div>
            </div>

            <div className="sss-admin-field">
              <label htmlFor="customizable" className="sss-admin-label">
                Customization
              </label>
              <select
                id="customizable"
                className="sss-admin-select"
                value={data.customizable}
                onChange={(e) => setData('customizable', e.target.value)}
              >
                <option value="false">None — buy as shown</option>
                <option value="true">Made to order — runs through the configurator</option>
              </select>
              <p className="sss-admin-hint">
                {'Steps are added after the piece is created.'}
              </p>
            </div>

            <UploadField
              label="Product images"
              files={selectedFiles}
              onAdd={(files) => setSelectedFiles([...selectedFiles, ...files])}
              onRemove={(index) => setSelectedFiles(selectedFiles.filter((_, i) => i !== index))}
            />

            <div className="sss-admin-actions">
              <button type="submit" className="sss-admin-btn sss-admin-btn--accent" disabled={processing}>
                {processing ? 'Creating…' : 'Create product'}
              </button>
              <Link href="/admin/products" className="sss-admin-btn sss-admin-btn--ghost">
                Cancel
              </Link>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  )
}
